import apiClient from "../common/apiClient";

export const getDocuments = async (page = 1, limit = 6, type = null) => {
  try {
    const params = { page, limit };
    if (type) {
      params.type = type;
    }
    const response = await apiClient.get("/document", { params });
    return response;
  } catch (error) {
    console.error("Error fetching documents:", error);
    throw error;
  }
};

export const getDocumentById = async (documentId) => {
  try {
    const response = await apiClient.get(`/document/${documentId}`);
    return response;
  } catch (error) {
    console.error("Error fetching document by id:", error);
    throw error;
  }
};

export const countDownloadDocument = async (documentId) => {
  try {
    const response = await apiClient.get(
      `/document/count-download/${documentId}`
    );
    return response;
  } catch (error) {
    console.error("Error counting document download:", error);
    throw error;
  }
};

export const getDocumentTopTrending = async (page = 1, limit = 7) => {
  try {
    const response = await apiClient.get("/document/top-trending", {
      params: { page, limit },
    });
    return response;
  } catch (error) {
    console.error("Error fetching top trending documents:", error);
    throw error;
  }
};

export const getLatestDocuments = async (limit = 7) => {
  try {
    const response = await apiClient.get("/document/latest", {
      params: { limit },
    });
    return response;
  } catch (error) {
    console.error("Error fetching latest documents:", error);
    throw error;
  }
};
